/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Live_Caption_Youtube_Region_HelpInputs */



/**
* | output |
* | --- |
* | "Choose where YouTube should position live captions on screen." |
*
* @param {Live_Caption_Youtube_Region_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const live_caption_youtube_region_help = /** @type {((inputs?: Live_Caption_Youtube_Region_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Live_Caption_Youtube_Region_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Choisissez où YouTube doit positionner les sous-titres en direct à l'écran.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Wählen Sie aus, wo YouTube die Live-Untertitel auf dem Bildschirm positionieren soll.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Scegli dove YouTube deve posizionare i sottotitoli in tempo reale sullo schermo.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Выберите, где YouTube должен размещать субтитры в режиме реального времени на экране.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Elige dónde debe YouTube colocar los subtítulos en directo en la pantalla.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("选择 YouTube 在屏幕上显示实时字幕的位置。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("YouTubeのライブ字幕を画面上のどこに表示するかを選択してください。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("यह चुनें कि YouTube स्क्रीन पर लाइव कैप्शन कहाँ प्रदर्शित करे।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Escolha onde o YouTube deve posicionar as legendas ao vivo na tela.")
	return /** @type {LocalizedString} */ ("Choose where YouTube should position live captions on screen.")
});